import firebase from 'firebase'
import 'firebase/firestore'

var config = {
	apiKey: "AIzaSyCaIH2YV_eIXFZnork3Dr3ZpfdkAh-OC7c",
	authDomain: "mangozpevnik.firebaseapp.com",
	databaseURL: "https://mangozpevnik.firebaseio.com",
	projectId: "mangozpevnik",
	storageBucket: "mangozpevnik.appspot.com",
	messagingSenderId: "931498781634"
};

// Zamezeni zobrazeni chyb. Pridat sem nejake externi logovani?
window.onerror = function(message, url, lineNumber) {
	console.log("Error: " + message + " in " + url + " at line " + lineNumber);
};

firebase.initializeApp(config);

const db = firebase.firestore();
const auth = firebase.auth();
const currentUser = auth.currentUser;

db.enablePersistence()
	.catch(function(err) {
		if (err.code === 'failed-precondition') {
			if (!window.location.href.includes("#/session/") && !window.location.href.includes("#/export/")) {
				alert("Zpěvník je možné mít otevřený jen v jedné záložce prohlížeče. Zavřete prosím ostatní záložky ve kterých je Mango zpěvník otevřen.")
			}
		} else if (err.code === 'unimplemented') {
			console.log("ERROR: unimplemented");
		}
	});

const songsCollection = db.collection("userSongs");
const playlistsCollection = db.collection("playlists");
const playlistsSongsCollection = db.collection("playlistsSongs");
const queueCollection = db.collection("queues");
const variablesCollection = db.collection("variables");

export {
	db,
	auth,
	currentUser,
	songsCollection,
	playlistsCollection,
	playlistsSongsCollection,
	queueCollection,
	variablesCollection
}
